import React, { useEffect, useState } from "react"
// import Project from './Project'
import Handler from "./Handler"
import RecentProject from './RecentProject'
import ProjectsFilterButtons from './ProjectsFilterButtons'
import { useGeneral } from "../../../context/general"
import { Skeleton, Typography, Grid, useMediaQuery, Pagination, Paper, Autocomplete, TextField, Box } from '@mui/material'
import './Projects.css'
import styles from './RecentProject.module.scss'
import { Padding } from "@mui/icons-material"

function GridItem(props) {
    return (
        <Grid item xs={12} sm={6} md={4} lg={3} {...props}>
            {props.children}
        </Grid>
    )
}
const filters=["Sector","Stock"]

export default function WatchlistHandler({ variant = 'watchlist' }) {
    const { handleCreateProjectAndOpen, WatchlistData } = useGeneral()
    const [filteredProjects, setFilteredProjects] = useState([])
    const [paginationPointer, setPaginationPointer] = useState(0)

    const [SectorData, setSectorData] = useState([])
    const [StockData, setStockData] = useState([])

    const [SelectedSectors,setSelectedSectors] = useState([])
    const [SelectedTickers,setSelectedTickers] = useState([])

    useEffect(() => {
        setPaginationPointer(0)
        return () => {}
    }, [filteredProjects] )

    // Decide how many columns to display
    const col4 = useMediaQuery(theme => (theme.breakpoints.up('lg'))) && 4
    const col3 = useMediaQuery(theme => (theme.breakpoints.up('md'))) && 3
    const col2 = useMediaQuery(theme => (theme.breakpoints.up('sm'))) && 2
    const col1 = useMediaQuery(theme => (theme.breakpoints.up('xs'))) && 1
    const numberOfColumns = col4 || col3 || col2 || col1

    const render_message = (text) => (
        <Paper elevation={0} className="projectCard projectCard-cta">
            <Typography variant="h4">{text}</Typography>
        </Paper>
    )

    const pagination = {
        pages: Math.ceil(filteredProjects?.length / (numberOfColumns * 3)),
        perPage: numberOfColumns * 3
    }
    pagination.currentPage = Math.ceil( paginationPointer / pagination.perPage ) + 1
    
    const projectsPagination = (
        <Grid item xs={12} className="projectsPaginationContainer" key="projectsPagination">
            { pagination.pages > 1 && (
                <Pagination
                    count={pagination.pages}
                    page={pagination.currentPage}
                    onChange={(e, val) => setPaginationPointer(((val - 1) * pagination.perPage))}
                />)
            }
        </Grid>
    )


    const renderWatchlistProjects = () => {
        const watchlistProjectsComponent = filteredProjects
            .slice(paginationPointer, paginationPointer + pagination.perPage)
            .map((project) => (
                <GridItem key={project.project_id}>
                    <Handler 
                        ticker={project.value}
                        name={project.name}
                        uuid={project.project_uuid}
                        updated_at={project.updated_at}
                        currency_code={project.currency_code}
                        // {...project} 
                        handleCreateProjectAndOpen={handleCreateProjectAndOpen}/>
                </GridItem>
            ))
        return watchlistProjectsComponent.length > 0
            ? [...watchlistProjectsComponent, projectsPagination]
            : (<GridItem key='no-projects'>{render_message('No projects found')}</GridItem>)
    }
    
    const renderSkeleton = () => (
        <Grid item xs={12}>
            <Skeleton variant="rect" width="300px" height="350px" />
        </Grid>
    )

    
    const HandleChange = (value,item) =>{
        if(item=="Sector") setSelectedSectors([...new Set(value.map(item => item.name))])
        else setSelectedTickers([...new Set(value.map(item => item.name))])
    }

    useEffect(()=>{
        if (SelectedSectors.length>0){
            let tempData = WatchlistData.filter(item=>{
                return SelectedSectors.includes(item.sector)
            })
            if (SelectedTickers.length>0){
                tempData = tempData.filter(item => SelectedTickers.includes(`${item.name} (${item.value})`))
            }
            setFilteredProjects(tempData)
        }
        else if (SelectedTickers.length>0){ 

                let tempData = WatchlistData.filter(item => SelectedTickers.includes(`${item.name} (${item.value})`))
                setFilteredProjects(tempData)
            }
        else{
            setFilteredProjects(WatchlistData)
        }
        return () => {}
    },[SelectedSectors,SelectedTickers])


    useEffect(()=>{
        let uniqueStocks = [...new Set(WatchlistData.map(item => `${item.name} (${item.value})`
        ))];
        uniqueStocks = uniqueStocks.map(x=>{return{"name":x}})
        setStockData(uniqueStocks)
        let uniqueSectors = [...new Set(WatchlistData.map(item =>item.sector))]
        uniqueSectors = uniqueSectors.map(x=>{return{"name":x}})
        setSectorData(uniqueSectors)
        setFilteredProjects(WatchlistData)
        return () => {}
    },[WatchlistData])
    

    return (
        <>
            {/* <ProjectsFilterButtons
                // projects={watchlistProjects}
                WatchlistData={WatchlistData}
                filters={[
                    { label: 'Stock', key: 'stock' },
                    { label: 'Sector', key: 'sector' },
                ]}
                setFilteredProjects={setFilteredProjects}
            /> */}
            <div style={{display:'flex',justifyContent:'flex-start'}}>
                {filters.map(item=>
                    <Box width={300} style={{marginRight:'15px'}}>
                    <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={item=="Sector"?SectorData:StockData}
                        getOptionLabel={(option) => option.name}
                        onChange={(event,value)=>{HandleChange(value,item)}}
                        filterSelectedOptions
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label={item}
                        />
                        )}
                    />
                </Box>
                )}
            </div>
            <Grid container spacing={3} className='projectsContainer'>
                { filteredProjects.length==0 ? renderSkeleton() : renderWatchlistProjects() }
            </Grid>
            </>
            )
}